export default "__VITE_ASSET__BNDyAB4c__"